// src/components/Account/AddressesTab.js
import React from "react";
import DeleteModal from "../DeleteModal";

const AddressesTab = ({
  t,
  user,
  showDropdown,
  toggleDropdown,
  handleEditAddress,
  handleDeleteAddress,
  showAddressForm,
  setShowAddressForm,
  newAddress,
  setNewAddress,
  handleAddAddress,
  editingAddress,
  setEditingAddress,
  handleSaveEditedAddress,
  showEditModal,
  setShowEditModal,
  showDeleteModal,
  setShowDeleteModal,
  confirmDeleteAddress,
  showSuccessMessage,
  setShowSuccessMessage,
}) => {
  // Close edit/success modals on ESC
  React.useEffect(() => {
    const onKey = (e) => {
      if (e.key !== "Escape") return;
      if (showEditModal) setShowEditModal(false);
      if (showSuccessMessage) setShowSuccessMessage(false);
    };
    document.addEventListener("keydown", onKey);
    return () => document.removeEventListener("keydown", onKey);
  }, [showEditModal, showSuccessMessage, setShowEditModal, setShowSuccessMessage]);

  return (
    <div className="tab-content">
      <h2 onClick={() => toggleDropdown("addresses")}>
        {t("account.saved_addresses")} {showDropdown ? "▼" : "▶"}
      </h2>

      {showDropdown &&
        user.addresses.map((addr) => (
          <div key={addr.id} className="address-card">
            <p>
              {addr.street}, {addr.city}, {addr.postalCode}, {addr.country}
            </p>

            <div className="address-actions">
              <button className="edit-btn" onClick={() => handleEditAddress(addr)}>
                ✏️ {t("account.edit_address")}
              </button>
              <button
                className="delete-btn"
                onClick={() => handleDeleteAddress(addr.id)}
              >
                🗑 {t("account.delete_address")}
              </button>
            </div>
          </div>
        ))}

      <button className="add-btn" onClick={() => setShowAddressForm(!showAddressForm)}>
        {t("account.add_address")}
      </button>

      {/* Inline add form (unchanged) */}
      {showAddressForm && (
  <div className="address-form">
    <div className="address-form-inner">
      <div className="form-grid">
        <input
          className="ui-input"
          type="text"
          placeholder={t("account.street")}
          value={newAddress.street}
          onChange={(e) => setNewAddress({ ...newAddress, street: e.target.value })}
        />
        <input
          className="ui-input"
          type="text"
          placeholder={t("account.city")}
          value={newAddress.city}
          onChange={(e) => setNewAddress({ ...newAddress, city: e.target.value })}
        />
        <input
          className="ui-input"
          type="text"
          placeholder={t("account.postalCode")}
          value={newAddress.postalCode}
          onChange={(e) => setNewAddress({ ...newAddress, postalCode: e.target.value })}
        />
        <input
          className="ui-input"
          type="text"
          placeholder={t("account.country")}
          value={newAddress.country}
          onChange={(e) => setNewAddress({ ...newAddress, country: e.target.value })}
        />
      </div>

      <div className="actions">
        <button className="primary-btn" onClick={handleAddAddress}>
          {t("account.save_address")}
        </button>
      </div>
    </div>
  </div>
)}

      {/* EDIT ADDRESS — uses new modal-card */}
      {showEditModal && (
  <div
    className="modal-overlay"
    onClick={(e) => {
      if (e.target === e.currentTarget) setShowEditModal(false);
    }}
  >
    <div className="modal-card compact">
      <h3 className="modal-title">{t("account.edit_address_title")}</h3>

      <div className="form-grid">
        <input
          className="ui-input"
          type="text"
          placeholder={t("account.street")}
          value={editingAddress.street}
          onChange={(e) =>
            setEditingAddress({ ...editingAddress, street: e.target.value })
          }
        />

        <input
          className="ui-input"
          type="text"
          placeholder={t("account.city")}
          value={editingAddress.city}
          onChange={(e) =>
            setEditingAddress({ ...editingAddress, city: e.target.value })
          }
        />

        <input
          className="ui-input"
          type="text"
          placeholder={t("account.postalCode")}
          value={editingAddress.postalCode}
          onChange={(e) =>
            setEditingAddress({ ...editingAddress, postalCode: e.target.value })
          }
        />

        <input
          className="ui-input"
          type="text"
          placeholder={t("account.country")}
          value={editingAddress.country}
          onChange={(e) =>
            setEditingAddress({ ...editingAddress, country: e.target.value })
          }
        />
      </div>

      <div className="modal-actions">
        <button className="primary-btn" onClick={handleSaveEditedAddress}>
          {t("account.save_changes")}
        </button>
        <button className="secondary-btn" onClick={() => setShowEditModal(false)}>
          {t("account.cancel")}
        </button>
      </div>
    </div>
  </div>
)}

      {/* DELETE CONFIRM — reuse shared DeleteModal */}
      {showDeleteModal && (
        <DeleteModal
          title={t("account.delete_address_confirm_title")}
          message={t("account.delete_address_confirm_message")}
          confirmText={t("account.delete_address_yes")}
          cancelText={t("account.cancel")}
          onConfirm={confirmDeleteAddress}
          onCancel={() => setShowDeleteModal(false)}
        />
      )}

      {/* SUCCESS MESSAGE — also uses glass modal */}
      {showSuccessMessage && (
        <div
          className="modal-overlay"
          onClick={(e) => {
            if (e.target === e.currentTarget) setShowSuccessMessage(false);
          }}
        >
          <div className="modal-card compact">
            <h3 className="modal-title">{t("account.delete_address_success")}</h3>
            <div className="modal-actions">
              <button
                className="primary-btn"
                onClick={() => setShowSuccessMessage(false)}
              >
                {t("account.close")}
              </button>
            </div>
          </div>
        </div>
      )}
    </div>
  );
};

export default AddressesTab;